// authActions.js
import { LOADING_START, LOADING_STOP } from '../types';

export const loadingStartAction = () => ({
  type: LOADING_START,
  payload: true,
});

export const loadingStopAction = () => ({
  type: LOADING_STOP,
  payload: false,
});